import config from 'config';
import request from 'helpers/superagent';
import {meInit} from 'modules/me/actions';

export default () => {
  const {access_token} = localStorage;
  return request.get(config.eadmin.baseUrl + '/account/me')
    .query({
      access_token,
    })
    .endAsync()
    .get('body')
    .then((me) => {
      localStorage.me = JSON.stringify(me);
      meInit();
    });
};



/** WEBPACK FOOTER **
 ** ./src/app/helpers/fetchMeAsync.js
 **/